import React from 'react';
import { Home, Building, Store, HardHat, Package, Calendar } from 'lucide-react';
import { content } from '../data/mock';
import './Services.css';

const iconMap = {
  home: Home,
  building: Building,
  store: Store,
  'hard-hat': HardHat,
  package: Package,
  calendar: Calendar
};

const Services = ({ language }) => {
  const t = content[language].services;

  return (
    <section id="services">
      <div className="container">
        <div className="section-head">
          <h2>{t.title}</h2>
          <p>{t.subtitle}</p>
        </div>

        <div className="grid-3">
          {t.items.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <article key={index} className="card">
                <div className="icon">
                  <Icon size={28} strokeWidth={2.5} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
